import { Component, Input } from '@angular/core';

@Component({
  selector: 'hfc-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  @Input()
  public closeButton: boolean;
}
